import{__exports as e}from"../../../../_virtual/config.js";Object.defineProperty(e,"__esModule",{value:!0}),e.DEFAULT_BASE_URL=void 0,e.DEFAULT_BASE_URL="https://safe-client.safe.global";export{e as default};
